// String-valued so the runtime values stay debuggable/serializable while
// consumers compare against SessionStatus (e.g. `status === SessionStatus.Authenticated`).
export const SessionStatus = {
  Loading: 'loading', // no settled answer yet (first load, transient failure, or throttle-skip)
  Authenticated: 'authenticated', // the last validation confirmed a valid session
  Unauthenticated: 'unauthenticated', // signed out (anonymous ssohint or a refresh 401/403)
} as const;
export type SessionStatus = typeof SessionStatus[keyof typeof SessionStatus];

export type SessionState = {
  status: SessionStatus;
  /** `status === SessionStatus.Authenticated` — authed and validated. */
  isAuthed: boolean;
  /** A validation request is in flight right now, independent of `status` — e.g. a
   * background re-check while already authenticated. */
  isValidating: boolean;
  /** No settled answer yet and a validation is in flight (the first-load check). */
  isLoading: boolean;
};
